import React, {useState} from 'react';
import {Column, Row} from '../../components/layout';
import * as fonts from '../../util/fonts';
import colors from '../../util/colors';
import {useSelector} from 'react-redux';
import {strings} from '../../util/strings';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '../permissions/components/TabPanel';
import './styles.scss';
import AccountData from './AccountData';
import PersonalData from './PersonalData';
import {useLocation} from 'react-router-dom';

const Myprofile = () => {
  const location: any = useLocation();

  const labels = useSelector((state: any) => ({
    ...state.strings.value.pt.myProfile,
    ...state.strings.value.pt.myData,
  }));
  const buStyles = useSelector((state: any) => state.globalStyles.value);
  const buFunctionalities = useSelector(
    (state: any) => state.busFunctionalities.value,
  );
  const tenant = useSelector((state: any) => state.tenant.value);

  const [tabValue, setTabValue] = useState(
    location?.state?.openIban ? (tenant.country === 'RS' ? 0 : 1) : 0,
  );

  const allLabels = {...strings.pt.myProfile, ...strings.pt.myData, ...labels};
  const tabIndicatorStyle = {style: {backgroundColor: 'transparent'}};
  const tabIndicatorMinHeight = {minHeight: '30px'};
  const permissionsTabsTitles = {
    ...fonts.M,
    ...fonts.Bold,
    paddingBottom: '12px',
    color: tabValue === 0 ? colors.white : buStyles.primaryColor,
  };
  const permissionsTabsTitlesNotClient = {
    ...fonts.M,
    ...fonts.Bold,
    paddingBottom: '12px',
    color: tabValue === 1 ? colors.white : buStyles.primaryColor,
  };

  const isNotClient = buFunctionalities[0].buId === 'NOTCLIENT';
  const isServiaPortal = tenant?.country === 'RS';

  const handleTab = (event: React.ChangeEvent<{}>, value: any) => {
    setTabValue(value);
  };

  const personalDataTabIndex = isServiaPortal ? 0 : 1;

  return (
    <>
      <Row className="bg-white profile-container">
        <Column>
          <Row className="profile-firstrow">
            <Column className="profile-title-column">
              <Row className="profile-title-row">
                <p
                  className="mb-0"
                  style={{
                    ...fonts.XL,
                    ...fonts.Bold,
                    color: colors.black,
                  }}>
                  {allLabels?.myProfile_pageTitle}
                </p>
              </Row>
              <Row className="profile-title-row p-0 m-0">
                <p
                  className="profile-subtitle"
                  style={{
                    ...fonts.M,
                    color: colors.black,
                  }}>
                  {allLabels?.profile_pageSubtitle}
                </p>
              </Row>
            </Column>
          </Row>
        </Column>
      </Row>
      <Row className="bg-white profile-container">
        <div className="tabs">
          <Tabs
            className="profile-tab-parent"
            value={tabValue}
            orientation="horizontal"
            onChange={handleTab}
            indicatorColor="primary"
            TabIndicatorProps={tabIndicatorStyle}
            style={tabIndicatorMinHeight}>
            {!isServiaPortal && (
              <Tab
                className="profile-tab"
                label={
                  <span style={permissionsTabsTitles}>
                    {allLabels.profile_accountData_tab}
                  </span>
                }
                wrapped={false}
              />
            )}
            {!isNotClient && (
              <Tab
                className="profile-tab"
                label={
                  <span style={permissionsTabsTitlesNotClient}>
                    {allLabels.profile_personalData_tab}
                  </span>
                }
                wrapped={false}
              />
            )}
          </Tabs>
          <div
            className="profile-separator"
            style={{backgroundColor: colors.black, height: '2px'}}
          />
          {!isServiaPortal && (
            <TabPanel value={tabValue} index={0} className="profile-tab-panel">
              <AccountData />
            </TabPanel>
          )}
          {!isNotClient && (
            <TabPanel
              value={tabValue}
              index={personalDataTabIndex}
              className="profile-tab-panel">
              <PersonalData />
            </TabPanel>
          )}
        </div>
      </Row>
    </>
  );
};

export default Myprofile;
